(function() {
    'use strict';

    class MediaListService {
        constructor($http, INFLUENCERS_URL) {
            this.$http = $http;
            this.influencersUrl = INFLUENCERS_URL;
        }

        getById(id) {
            let url = `${this.influencersUrl}/mediaLists/${id}`;
            return this.$http.get(url).then((response) => {
                if (response && response.data) {
                    return response.data;
                }
            });
        }
    }  
    
    angular
        .module('MW.Influencers.MediaListService', [])
        .service('MediaListService', [
            '$http',
            'INFLUENCERS_URL',
            MediaListService
        ]);
})();